module.exports = __webpack_public_path__ + "4318e5690723dd0aed1cea57e2a4edc9.pdf";